/** PURE_IMPORTS_START ._ErrorObservable PURE_IMPORTS_END */
import { ErrorObservable } from './ErrorObservable';
export var _throw = ErrorObservable.create;
//# sourceMappingURL=throw.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/throw.js
// module id = 781
// module chunks = 0